import { message } from 'ant-design-vue'
import {
  common_queryCountryInfo_post,
  common_querySiteInfo_post,
  common_queryStateInfo_post,
  common_queryLanguageInfo_post,
  common_uploadFile_post,
  common_querySiteInfo_get,
  common_lang_get
} from 'server/modules/3426'
// queryCountryInfo
export const common_queryCountryInfo_post_ = async function(params) {
  const { success, data, retInfo } = await common_queryCountryInfo_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// querySiteInfo
export const common_querySiteInfo_post_ = async function(params) {
  const { type } = params
  const { success, data, retInfo } = await common_querySiteInfo_post({})
  if (success) {
    switch (type) {
      case 1:
        params.state.brands = data
        break
      case 2:
        params.state.channels = data
        break
      case 3:
        params.state.sites = data
        break
      case 4:
        params.state.terminals = data
        break
    }
  } else {
    message.error(retInfo)
  }
}

// queryStateInfo
export const common_queryStateInfo_post_ = async function(params) {
  const { success, data, retInfo } = await common_queryStateInfo_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// queryLanguageInfo
export const common_queryLanguageInfo_post_ = async function(params) {
  const { success, data, retInfo } = await common_queryLanguageInfo_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 上传文件
export const common_uploadFile_post_ = async function(params) {
  const { success, data, retInfo } = await common_uploadFile_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
// 查询四要素集合
export const common_querySiteInfo_get_ = async function(
  { state },
  cb = () => {}
) {
  const { success, data, retInfo } = await common_querySiteInfo_get()
  if (success) {
    for (let [key, items] of Object.entries(data)) {
      switch (key) {
        case '1':
          state.brands = items
          break
        case '2':
          state.channels = items
          break
        case '3':
          state.sites = items
          break
        case '4':
          state.terminals = items
          break
      }
    }
    cb()
  } else {
    message.error(retInfo)
  }
}

// 查询四要素集合
export const common_lang_get_ = async function(params, state) {
  const { success, data, retInfo } = await common_lang_get(params)
  if (success) {
    const { languageMap } = data || { languageMap: {} }
    state.defaultCurrency = data.defaultCurrency || '未配置默认币种'
    let langList = []
    for (let [label, value] of Object.entries(languageMap || {})) {
      langList.push({ value, label })
    }
    const HasDefaultLangCode = langList?.find(
      v => v.value === data.defaultLanguageCode
    )
    if (langList && langList.length) {
      state.defaultLanguageCode = HasDefaultLangCode
        ? data.defaultLanguageCode
        : langList[0]?.value
      const index = langList.findIndex(
        v => v.value === state.defaultLanguageCode
      )
      state.defaultLanguageIndex = index > -1 ? index : 0
      state.langCode = HasDefaultLangCode
        ? data.defaultLanguageCode
        : langList[0]?.value
    } else {
      state.langCode = null
    }
    state.langDic = langList
    return langList
  } else {
    message.error(retInfo)
  }
}
